import { render } from "./MrsdSpliceViewer.vue?vue&type=template&id=90e55c5c&scoped=true"
import script from "./MrsdSpliceViewer.vue?vue&type=script&lang=js"
export * from "./MrsdSpliceViewer.vue?vue&type=script&lang=js"

import "./MrsdSpliceViewer.vue?vue&type=style&index=0&id=90e55c5c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/RNAseq_web/prime_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e55c5c"]])

export default __exports__